import './Settings.sass';

import React from 'react';

import Spinner from '../../../commonComponents/Spinner/Spinner';
import { canPerformAction } from '../../../utilities/permissionUtils';
import SettingRow from './SettingRow';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.onLoad();
  }

  render() {
    const { permissions = [] } = this.props;
    const canEdit = canPerformAction('Settings.Keys.Manage', permissions);
    return (
      <div className="settingsPageContainer">
        <div className="title">Settings</div>
        {this.props.loading ? (
          <div className="settings-spinner">
            <Spinner text="Loading" />
          </div>
        ) : (
          <div className="keysContainer">
            {this.props.settings.map((setting) => (
              <SettingRow
                key={`setting-key${setting.id}`}
                setting={setting}
                handleSubmit={this.props.handleSubmit}
                updateKey={this.props.updateKey}
                disabled={!canEdit}
                showWarning={this.props.showWarning}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Settings;
